/*
 * Local DSA progress — records which question_ids the learner has solved
 * (an "accepted" judge verdict) in localStorage. Real, per-browser progress
 * that powers the "solved" counts on the browse page. When the Brain's memory
 * layer lands, this can move server-side.
 */
const KEY = 'nano_dsa_solved';

export function getSolvedSet() {
  try {
    return new Set((JSON.parse(localStorage.getItem(KEY) || '[]') || []).map(Number));
  } catch {
    return new Set();
  }
}

export function isSolved(qid) {
  return getSolvedSet().has(Number(qid));
}

export function markSolved(qid) {
  const set = getSolvedSet();
  set.add(Number(qid));
  try { localStorage.setItem(KEY, JSON.stringify([...set])); } catch { /* ignore quota */ }
  return set;
}

export function solvedCount() {
  return getSolvedSet().size;
}
